import React from "react";
import style from "./index.module.scss";

interface UrlListProps {
    file: string[];
}
export default function UrlList({ file }: UrlListProps) {
    const handleDownload = (url: string) => {
        window.open(url);
    };

    const getName = (item: string) => {
        return item?.split("attname=").pop();
    };

    return (
        <div className={style.root}>
            {file.map(item => (
                <div
                    key={item}
                    className={style.item}
                    onClick={() => handleDownload(item)}>
                    {getName(item)}
                </div>
            ))}
        </div>
    );
}
